export default __webpack_public_path__ + "static/media/SANRAFAEL.1f332b78.png";